/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 1/8/20
 * Time: 4:33 PM
 */

import React, {Component} from 'react';
import {MDBModal} from "mdbreact";
import VisitorForward_ from "./VisitorForward_/VisitorForward_";

class App extends Component {
  state = {
    access: true
  };

  componentDidMount() {
    document.title = "Forward This Meeting To Another Visitor"
  }
  toggle = () => {

  };
  render() {
    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl" className={"reg-form-main-content"}>

          <h4 className={"reg-form-main-topic"}>Forward This Meeting To Another Participants</h4>
          <VisitorForward_ settleAccess={(codition)=>this.setState({access:codition})}/>

        </MDBModal>
        {
          !this.state.access ?
            <div className={"warning-page"}>
              <i className="fa fa-exclamation-triangle" aria-hidden="true"/> Sorry you can't access this page!
            </div> : null
        }
      </div>
    );
  }
}

export default App;
